(function () {
  angular
    .module('kareo.ui.shared.modules.api.k-product-setup-service', [])
    .factory('kProductSetupService', kProductSetupService);

  kProductSetupService.$inject = ['$http'];
  function kProductSetupService($http) {
    var productSetupApiURL = '/product-setup-ui/api/ProductSetup/setuprequired';

    var svc = {};

    svc.checkRequireProductSetup = checkRequireProductSetup;

    return svc;

    //---------------------------------------------------------------------------

    function checkRequireProductSetup() {
      return $http
        .get(productSetupApiURL, { cache: true })
        .then((response) => {
          return response.data;
        });
    }
  }
})();
